import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      <section className="hero text-white">
        <div className="row g-4 align-items-center">
          <div className="col-lg-7">
            <div className="badge-soft mb-3">Fictional launch · Built for 2025 teams</div>
            <h1 className="display-5 fw-bold mb-3">
              Adaptive product intelligence for teams that{" "}
              <span className="accent-underline">ship weekly</span>.
            </h1>
            <p className="lead tagline">
              PulseFrame blends customer signals, revenue data, and shipping velocity into one luminous
              control surface. Think bento dashboards, AI guidance, and zero-latency status for your
              next release.
            </p>
            <div className="d-flex gap-3 mt-4">
              <Link className="cta-btn primary" to="/pricing">
                Start free trial
              </Link>
              <Link className="cta-btn secondary" to="/features">
                See how it works
              </Link>
            </div>
            <div className="d-flex gap-3 mt-4 flex-wrap">
              <div className="pill">
                <i className="bi bi-lightning-charge"></i> Live roadmap sync
              </div>
              <div className="pill">
                <i className="bi bi-magic"></i> AI-guided briefs
              </div>
              <div className="pill">
                <i className="bi bi-shield-check"></i> SOC2-ready
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="glass-card h-100">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="pill">Experience preview</span>
                <span className="badge-soft">
                  <i className="bi bi-toggle-on"></i> Theme aware
                </span>
              </div>
              <div className="bento-grid">
                <div className="glass-card">
                  <div className="icon-chip mb-3">
                    <i className="bi bi-graph-up-arrow"></i>
                  </div>
                  <div className="metric">+214%</div>
                  <div className="text-muted">Quarterly feature adoption uplift</div>
                </div>
                <div className="glass-card">
                  <div className="icon-chip mb-3">
                    <i className="bi bi-mouse"></i>
                  </div>
                  <h6 className="mb-1">Micro-interactions</h6>
                  <p className="mb-0 text-muted">
                    Smooth hover + depth cues align with 2025 bento layouts.
                  </p>
                </div>
                <div className="glass-card">
                  <div className="icon-chip mb-3">
                    <i className="bi bi-broadcast"></i>
                  </div>
                  <h6 className="mb-1">Signal mesh</h6>
                  <p className="mb-0 text-muted">
                    Blend usage, NPS, and pipeline to steer next release.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="section-title mb-0">What makes PulseFrame different</h2>
          <Link className="btn btn-sm btn-outline-light" to="/features">
            Explore features
          </Link>
        </div>
        <div className="bento-grid">
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-cpu"></i>
            </div>
            <h5>AI briefs that stay on-brand</h5>
            <p className="text-muted mb-0">
              Auto-generate release briefs and QA steps grounded in live telemetry. No hallucinated
              requirements.
            </p>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-grid-1x2"></i>
            </div>
            <h5>Bento dashboards</h5>
            <p className="text-muted mb-0">
              Composable tiles with glassmorphic depth and neon cues for critical signals.
            </p>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-clock-history"></i>
            </div>
            <h5>Latency: near-zero</h5>
            <p className="text-muted mb-0">
              Streams ship health in real time; optimized for async squads spread globally.
            </p>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h5>Enterprise guardrails</h5>
            <p className="text-muted mb-0">
              SOC2, SSO, audit timelines baked in so security teams relax.
            </p>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="row g-3">
          <div className="col-md-4">
            <div className="glass-card h-100">
              <div className="pill mb-2">
                <i className="bi bi-brush"></i> Design
              </div>
              <h5>Mono minimal aesthetic</h5>
              <p className="text-muted">
                A clean, high‑contrast palette keeps the focus on your product story.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="glass-card h-100">
              <div className="pill mb-2">
                <i className="bi bi-bag-check"></i> Pricing fit
              </div>
              <h5>Made for lean teams</h5>
              <p className="text-muted">
                Simple plans, transparent usage bands. No dark patterns—just a modern UI that converts.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="glass-card h-100">
              <div className="pill mb-2">
                <i className="bi bi-emoji-smile"></i> Delightful motion
              </div>
              <h5>Micro-interactions</h5>
              <p className="text-muted">
                Hover lifts, soft glows, and glass surfaces match 2025 aesthetic trends without hurting
                readability.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
